import styles from './styles.module.scss';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import React, { useState } from 'react';
import { NumericFormat } from 'react-number-format';

type EditableMileageProps = {
  initialValue?: string;
  onApply?: (value: string) => void;
  isDisabled?: boolean;
};

export const EditableMileage: React.FC<EditableMileageProps> = ({ initialValue = '', onApply, isDisabled }) => {
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);

  const numericValue = parseInt(value, 10);
  const isValid = !isNaN(numericValue) && numericValue > 0;

  const handleToggle = () => {
    if (isEditing && isValid) {
      onApply?.(value);
      setIsEditing(false);
    } else if (!isEditing) {
      setIsEditing(true);
    }
  };

  return (
    <div className="d-flex align-items-center">
      {isEditing ? (
        <NumericFormat
          value={value}
          onValueChange={(values) => setValue(values.value)}
          allowNegative={false}
          decimalScale={0}
          allowLeadingZeros={false}
          className={clsx(styles.editableInput, 'form-control form-control-sm form-control-solid')}
        />
      ) : (
        <span className="fw-semibold fs-7 text-gray-800">{value || '-'}</span>
      )}
      <div>
        <button
          onClick={handleToggle}
          className={styles.editableButton}
          disabled={isDisabled || (isEditing && !isValid)}
        >
          {isEditing ? (
            <InlineSvg path="/media/icons/custom/check-circle-not-checked.svg" />
          ) : (
            <InlineSvg path="/media/icons/custom/pencil.svg" />
          )}
        </button>
      </div>
    </div>
  );
};
